import { css } from "@emotion/css"

const summaryClass = css`
  height: 46px;
  padding: 0px 12px 0px 24px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
`
const summaryTitle = css`
  color: #2f323a;
  display: flex;
  align-items: center;
`

const summaryMarkers = css`
  color: var(--primary-main);
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 73px;
`
const subRegionClass = css`
  width: 989px;
`

const marketsClass = css`
  padding: 12px 95px 28px 20px;
  display: none;
`
const openMarkets = css`
  display: block;
`

const section = css`
  font-size: 14px;
  color: var(--black);
  margin-bottom: 45px;

  > * {
    margin-bottom: 13px;
  }
`
const createNew = css`
  font-size: 13px;
  color: var(--primary-main);
  margin-left: 22px;
  cursor: pointer;
`

export {
  summaryClass,
  summaryMarkers,
  summaryTitle,
  subRegionClass,
  marketsClass,
  section,
  createNew,
  openMarkets,
}
